import { Toaster } from '@/components/ui/sonner'
import { TOASTER_POSITION_TO_SONNER } from '@/constant/toaster'
import { useToasterSetting } from '@/hooks/use-toaster-setting'

/**
 * App-wide toaster that applies the active organisation's toaster setting.
 * Renders with the defaults until the setting loads, so toasts fired early are never dropped.
 */
const OrganisationToaster = () => {
  const { toasterSetting } = useToasterSetting()

  return (
    <Toaster
      position={TOASTER_POSITION_TO_SONNER[toasterSetting.position]}
      richColors
      closeButton={toasterSetting.closeButton}
      expand={toasterSetting.expand}
      duration={toasterSetting.duration}
      visibleToasts={toasterSetting.visibleToasts}
    />
  )
}

export default OrganisationToaster
